import React, { memo, useMemo } from 'react';

import { Label, Input } from './SwitchButton.styles';

import { guid } from '../../../utils/guid';
import ColorConstants from '../../../constants/ColorConstants';
import TEST_IDS from '../../../utils/_tests/testIds.constants';

interface SwitchButton {
  className: string;
  checked: Boolean;
  disabledBackground: string;
  enabledBackground: string;
  isDisable: Boolean;
  buttonBackground: string;
  onChange: Function;
  labelProps: Object;
  inputProps: Object;
  dataAppcuesId?: string;
}

const defaultProps = {
    className: null,
    checked: null,
    disabledBackground: ColorConstants.salmon,
    enabledBackground: ColorConstants.padua,
    onChange: null,
    isDisable: false,
    labelProps: {},
    buttonBackground: ColorConstants.white,
    inputProps: {},
};

const SwitchButton = ({
    checked,
    className,
    disabledBackground,
    enabledBackground,
    isDisable,
    onChange,
    labelProps,
    inputProps,
    dataAppcuesId,
}: SwitchButton) => {
    const inputId = inputProps.id || null;
    const id = useMemo(() => inputId || `switch-shadow-${guid()}`, [inputId]);

    return (
        <div className={className} data-appcues-id={dataAppcuesId}>
            <Input
                checked={checked}
                disabledBackground={disabledBackground}
                enabledBackground={enabledBackground}
                id={id}
                onChange={onChange}
                type="checkbox"
                data-testid={TEST_IDS.SWITCH.SWITCH_INPUT}
                disabled={isDisable}
                {...inputProps}
            />
            <Label
                disabledBackground={disabledBackground}
                enabledBackground={enabledBackground}
                htmlFor={id}
                {...labelProps}
            />
        </div>
    );
};

SwitchButton.defaultProps = defaultProps;

export default memo(SwitchButton);
